import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

import {
  Checkbox,
  TableCell,
  TableRow,
} from '@mui/material';

import TableHeadCol from './TableHeadCol';
import TranslationsContext from '../../Container/Language/TranslationsContext';

const TableHead = (props) => {
  const { t } = useContext(TranslationsContext);

  const { useDrag } = props;
  const { head } = props;
  const { onSelectAllClick } = props;
  const { numSelected } = props;
  const { rowCount } = props;
  const { showCheckbox, showAction } = props;
  const { filters, setFilters } = props;

  if (!head.length) {
    return null;
  }

  const tableCheckboxCellProps = {
    padding: 'checkbox',
  };
  const checkboxProps = {
    color: 'error',
    size: 'small',
    indeterminate: numSelected > 0 && numSelected < rowCount,
    checked: rowCount > 0 && numSelected === rowCount,
    onChange: onSelectAllClick,
    inputProps: {
      'aria-label': 'select all',
    },
    sx: ({ palette }) => ({
      color: palette.error.main,
      p: 0,
    }),
  };

  return (
    <TableRow>
      {showCheckbox ? (
        <TableCell {...tableCheckboxCellProps}>
          <Checkbox {...checkboxProps} />
        </TableCell>
      ) : null}

      {head.map((cell) => (
        <TableHeadCol
          key={v4()}
          {...props}
          cell={cell}
          filter={filters[cell.name] || ''}
          setFilter={(v) => setFilters({ ...filters, [cell.name]: v })}
        />
      ))}

      {showAction ? <TableCell>{t('app:common:actions')}</TableCell> : null}

      {useDrag ? <TableCell width={57} /> : null}
    </TableRow>
  );
};

TableHead.propTypes = {
  head: PropTypes.instanceOf(Array),
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  onSelectAllClick: PropTypes.func,
  numSelected: PropTypes.number,
  rowCount: PropTypes.number,
  showCheckbox: PropTypes.bool,
};

TableHead.defaultProps = {
  head: [],
  onSelectAllClick() {},
  numSelected: 0,
  rowCount: 0,
  showCheckbox: false,
};

export default TableHead;
